import { tw } from "@careinfo/tailwind";
import { FormProvider, useFieldArray, useForm } from "react-hook-form";
import Button from "../../Reusable/Button";
import Card from "../../Reusable/Card";
import JournalEntryForm from "../Form";
import { yupResolver } from "@hookform/resolvers/yup";
import journalEntrySchema from "../../../validation/JournalEntry";
import { useNavigate } from "react-router-dom";
import PopupModal from "../../Reusable/Modal";
import { useEffect, useState } from "react";
import CreateAccountPopup from "../../Transaction/CreateAccountPopup";
import { getKey } from "../../../helpers/sessionKey";

export default function EditJournalEntry({
  handleEdit,
  isLoading,
  data,
  openPrintPopup,
  setOpenPrintPopup,
  isPrintLoading,
  handlePrint,
  handleCancel,
  handleRevert,
  isRevertLoading,
  handleCreateAccount,
  isPostLoading,
}: any) {
  const [openAccountPopup, setOpenAccountPopup] = useState(false);
  const [openCancelBiLLPopup, setOpenCancelBillPopup] = useState(false);
  const formMethods = useForm({
    resolver: yupResolver(journalEntrySchema),
    defaultValues: {
      ...data,
      type: {
        name: data?.type,
        value: data?.type,
      },
    },
  });
  const { control } = formMethods;

  const { fields, append, remove } = useFieldArray({
    control,
    name: "journal_account",
  });

  const handleAddRow = () => {
    append({
      account: "",
      debit: 0,
      credit: 0,
    });
  };
  const navigate = useNavigate();
  const handleClosePrint = () => {
    setOpenPrintPopup(false);
    navigate("/accounting/journal-voucher");
  };
  const isSuperUser = getKey("is_superuser");
  const adminOnly = data?.is_draft;

  const journalAccounts = formMethods.watch("journal_account");

  return (
    <>
      <Card>
        <form
          onSubmit={formMethods.handleSubmit((data: any) =>
            handleEdit(data, false, formMethods.setError)
          )}
          autoComplete="off"
          className={tw`rounded-md`}
        >
          <FormProvider {...formMethods}>
            <JournalEntryForm
              isDraft={data?.is_draft}
              setOpenAccountPopup={setOpenAccountPopup}
              handleAddRow={handleAddRow}
              append={append}
              isEdit={true}
              remove={remove}
              fields={fields}
            />
          </FormProvider>
          <div className={tw`w-full flex gap-x-4 justify-end px-4`}>
            {/* <div className={tw`w-24 `}>
              <Button
                type="button"
                // disabled={!adminOnly}
                label="Cancel"
                isLoading={isLoading}
                onClick={() => setOpenCancelBillPopup(true)}
              />
            </div> */}
            {data?.is_draft ? (
              <div className={tw`w-24 `}>
                <Button
                  type="button"
                  isLoading={isLoading}
                  label="Save to Draft"
                  disabled={!data?.is_draft}
                  onClick={formMethods.handleSubmit((data) =>
                    handleEdit(data, true, formMethods.setError)
                  )}
                />
              </div>
            ) : (
              <div className={tw`w-24 `}>
                <Button
                  type="button"
                  // disabled={!adminOnly}
                  label="Revert"
                  isLoading={isRevertLoading}
                  onClick={() => handleRevert(formMethods.setError)}
                />
              </div>
            )}
            <div className={tw`w-24`}>
              <Button
                label="Submit"
                disabled={!data?.is_draft}
                isLoading={isLoading}
              />
            </div>
          </div>
        </form>
      </Card>
      <PopupModal
        isOpen={openAccountPopup}
        setIsOpen={setOpenAccountPopup}
        title="Create Account"
      >
        <CreateAccountPopup
          handleCreateAccount={handleCreateAccount}
          isLoading={isPostLoading}
          setOpenAccountPopup={setOpenAccountPopup}
        />
      </PopupModal>
      <PopupModal
        isOpen={openCancelBiLLPopup}
        setIsOpen={setOpenCancelBillPopup}
        title="Cancel Bill"
      >
        <div className={tw`p-4 mt-10`}>
          <p className={tw`text-gray-600 mb-6`}>
            Are you sure you want to cancel this bill? This action cannot be
            undone.
          </p>

          <div className={tw`flex justify-center gap-3`}>
            <button
              onClick={() => setOpenCancelBillPopup(false)}
              className={tw`px-6 py-2 rounded-md focus:outline-none bg-gray-200 text-gray-800 hover:bg-gray-300 transition`}
            >
              No
            </button>

            <button
              onClick={() => {
                handleCancel();
                setOpenCancelBillPopup(false);
              }}
              className={tw`px-6 py-2 rounded-md  focus:outline-none bg-red-600 text-white hover:bg-red-700 transition`}
            >
              Yes
            </button>
          </div>
        </div>
      </PopupModal>
      <PopupModal
        isOpen={openPrintPopup}
        setIsOpen={handleClosePrint}
        title={"Print"}
      >
        <form action="#" className={tw`w-[600px]`}>
          <Button
            label={"Print "}
            type="button"
            isLoading={isPrintLoading}
            disabled={isPrintLoading}
            onClick={handlePrint}
            autoFocus
          />
          <Button
            type="button"
            label={"Close"}
            onClick={() => handleClosePrint()}
          />
        </form>
      </PopupModal>
    </>
  );
}

